import { stringToLocalFormattedDateString } from "@arenko-group/arenko-ui/dist/helpers";
// TODO - remove this and use date-fns to format the date
export default class TableProfileRowModel {
  value?: string;
  time?: string;

  constructor(data: { time: string; value: number }) {
    if (!data) {
      return;
    }
    const hasMs = (dateStr: string) => {
      if (dateStr) {
        const d = new Date(dateStr);
        const ms = d.getMilliseconds();
        return ms > 0;
      }
      return false;
    };

    this.time = data?.time
      ? stringToLocalFormattedDateString({
          date: data.time,
          withSeconds: true,
          withMilliseconds: hasMs(data?.time),
        })
      : "";
    this.value = data?.value !== undefined ? (data.value / 1e6).toFixed(1) : "";
  }
}
